import { TextToSubscribeButtonElement } from "@redotech/redo-model/content-builder/element-schema";
import { SUBSCRIBE_MESSAGE } from "@redotech/redo-model/signup-form";
import { createSecureSmsUri } from "@redotech/util/phone-number";
import { memo } from "react";
import { BrandKitButton } from "../../brand-kit-button";
import { FormElementProps } from "./index";

export const TextToSubscribeButton = memo(function TextToSubscribeButton({
  element,
  brandKit,
  brandKitOverrides,
  merchantPhoneNumber,
  anonymousId,
  submitting,
}: Pick<
  FormElementProps<TextToSubscribeButtonElement>,
  | "element"
  | "brandKit"
  | "brandKitOverrides"
  | "merchantPhoneNumber"
  | "anonymousId"
  | "submitting"
>) {
  const openSms = ({ to, body }: { to?: string[]; body?: string }) => {
    const uri = createSecureSmsUri({ phoneNumbers: to, body });

    if (uri) {
      window.location.href = uri;
    }
  };

  return (
    <BrandKitButton
      brandKit={brandKit}
      hierarchy={element.hierarchy}
      onClick={() => {
        const smsBody = anonymousId
          ? `${SUBSCRIBE_MESSAGE} ID:${anonymousId}`
          : SUBSCRIBE_MESSAGE;
        openSms({
          to: merchantPhoneNumber ? [merchantPhoneNumber] : undefined,
          body: smsBody,
        });
      }}
      override={
        brandKitOverrides.buttons.enabled
          ? brandKitOverrides.buttons
          : undefined
      }
      pending={submitting}
      text={element.text}
      type={element.action === "submit-and-advance" ? "submit" : "button"}
    />
  );
});
